import { TeamAccessEditDTO } from '../team/team-access-edit.dto';
import { IsNotEmpty, IsString, MaxLength, IsOptional, IsUUID, IsArray, MinLength } from 'class-validator';

export class ProductTestEditDTO extends TeamAccessEditDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(255)
    title: string;

    @IsOptional()
    @IsString()
    @MaxLength(3000)
    description: string;

    @IsNotEmpty()
    @IsUUID()
    version: string;

    @IsNotEmpty()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    checkpoints: Array<string>;

    @IsNotEmpty()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    users: Array<string>;

}
